/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatiRegistrazioneResDto } from '../../models/stati-registrazione-res-dto';

export interface StatiRegistrazioniControllerFindManystatiPianificazioni$Params {}

export function statiRegistrazioniControllerFindManystatiPianificazioni(
  http: HttpClient,
  rootUrl: string,
  params?: StatiRegistrazioniControllerFindManystatiPianificazioni$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<StatiRegistrazioneResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    statiRegistrazioniControllerFindManystatiPianificazioni.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<StatiRegistrazioneResDto>>;
      }),
    );
}

statiRegistrazioniControllerFindManystatiPianificazioni.PATH =
  '/StatiRegistrazioni';
